export const DEFAULT_QUOTATION_COLUMNS = {
  col1: 'Particulars',
  col2: 'Image',
  colVendor: 'Vendor',
  col3: 'Description',
  col4: 'Quantity',
  col5: 'Amount'
};

export const DEFAULT_QUOTATION_ROW = {
  particulars: '',
  image: '',
  vendor: '',
  description: '',
  quantity: 1,
  amount: 0
};
